import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { Modal, Field, Select, TextArea } from "@/pages/Notizie";

const CHI = [["agente", "Agente"], ["professionista", "Professionista"], ["notaio", "Notaio"], ["banca", "Banca"], ["altro", "Altro"]];
const oggi = () => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`; };

export function NuovaChiamata({ onClose, onSaved }) {
  const [f, setF] = useState({ chi: "agente", nome: "", telefono: "", motivo: "", data: oggi(), immobile_id: "" });
  const [imm, setImm] = useState([]);
  const [err, setErr] = useState({});
  const [saving, setSaving] = useState(false);
  useEffect(() => { api.get("/immobili").then((r) => setImm(r.data.filter((x) => !x._masked))).catch(() => {}); }, []);
  const s = (k) => (e) => { setF({ ...f, [k]: e.target.value }); if (err[k]) setErr({ ...err, [k]: undefined }); };
  const save = async () => {
    const e = {};
    if (!f.nome.trim()) e.nome = "Inserisci il nome";
    if (!f.motivo.trim()) e.motivo = "Scrivi il motivo";
    if (!f.data) e.data = "Scegli la data";
    setErr(e);
    if (Object.keys(e).length) return;
    setSaving(true);
    try { await api.post("/segreteria/chiamate", { ...f, immobile_id: f.immobile_id || null }); toast.success("Chiamata aggiunta"); onSaved(); }
    catch (x) { toast.error(apiError(x)); } finally { setSaving(false); }
  };
  return (
    <Modal title="Nuova chiamata" onClose={onClose} onSave={save} saving={saving} testid="nuova-chiamata-modal" saveLabel="Aggiungi chiamata">
      <div className="grid sm:grid-cols-2 gap-3">
        <Select label="Chi chiamare" testid="nc-chi" value={f.chi} onChange={s("chi")} opts={CHI} required />
        <Field label="Data" testid="nc-data" type="date" value={f.data} onChange={s("data")} error={err.data} required />
        <Field label="Nome" testid="nc-nome" value={f.nome} onChange={s("nome")} error={err.nome} required />
        <Field label="Telefono" testid="nc-telefono" value={f.telefono} onChange={s("telefono")} />
      </div>
      <div className="mt-3"><TextArea label="Motivo" testid="nc-motivo" rows={2} value={f.motivo} onChange={s("motivo")} error={err.motivo} required /></div>
      <div className="mt-3"><Select label="Immobile collegato (facoltativo)" testid="nc-immobile" value={f.immobile_id} onChange={s("immobile_id")}
        opts={[["", "— Nessuno —"], ...imm.map((x) => [x.id, x.titolo || x.indirizzo || "Immobile"])]} /></div>
    </Modal>
  );
}
